// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.6.0';
export const APP_NAME = 'busitalia-bruciatura-ticket';
export const FILE_HASH = '1758207251292';
export const BUILD_DATE = '2025-09-18T14:54:11.292Z';
/* tslint:enable */
